const Header = {
    init: (pgurl) => {
        Header.header = document.querySelector('.header')
        pgurl != '/' && pgurl != '/home' ? Header.header.classList.remove('header--hidden') : Header.header.classList.add('header--hidden');
    }
};

export default Header;    